import React from "react";
import { useLocation } from "react-router-dom";
import { API_URL } from "shared/config/properties";
import { AUTH_USER_ACTUAL } from "shared/constants/auth";

export function RouteInterceptor() {
  const location = useLocation();
  const hasRun = React.useRef<string | null>(null);

  React.useEffect(() => {
    if (hasRun.current !== location.pathname) {
      //@ts-ignore
      if (window && window.ReactNativeWebView) {
        if (localStorage.getItem(AUTH_USER_ACTUAL)) {
          const localUser = JSON.parse(
            localStorage.getItem(AUTH_USER_ACTUAL) || ""
          );

          //@ts-ignore
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              action: "setAuthToken",
              value: JSON.stringify({
                apiURL: API_URL,
                token: localUser.data.token,
                id: localUser.data.id,
              }),
            })
          );
        }
      }

      hasRun.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
}
